import { ReactElement } from "react";
import { TUserWorkflow, useUserWorkflow } from "./logic/useUserWorkflow";
import css from "./styles/uw-summary-card.module.scss";
import { Button } from "@zendeskgarden/react-buttons";
import { workflowTaskToResume } from "./userWorkflowUtils";
import { TaskStatusType } from "../../__generated__/generated_types";


export interface IUserWorkflowSummaryCardProps {
    workflow: TUserWorkflow;
}

export function UserWorkflowSummaryCard({workflow}: IUserWorkflowSummaryCardProps): ReactElement {
    const {enterWorkflow} = useUserWorkflow();

    const taskToResume = workflowTaskToResume(workflow);
    let continueText;

    if (workflow.tasks.every(task => task.currentStatus?.status == TaskStatusType.Complete)) {
        continueText = "All tasks complete";
    } else if (taskToResume) {
        continueText = `Continue with task: ${taskToResume?.title}`;
    } else {
        continueText = "No tasks";
    }

    return (
        <div className={css.uwSummaryCard}>
            <Button className={css.uwSummaryCardInner} isBasic onClick={() => enterWorkflow(workflow, null)}>
                <h5 className={css.cardTitle}>{workflow.title}</h5>
                <span>{continueText}</span>
            </Button>
        </div>
    );
}
